import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase";

// Hook en vivo para las "delegaciones" temporales por licencia (config/app.delegaciones).
// On/off manual desde el Panel de Admin. Al ser onSnapshot, el cambio se refleja en
// todos los dispositivos en el momento, sin recargar.
//
//   · ventasFactura          → Ventas puede facturar (reemplaza a Administración)
//   · administracionDespacha → Administración puede despachar (reemplaza a Ventas)
export function useDelegaciones() {
  const [deleg, setDeleg] = useState({ ventasFactura: false, administracionDespacha: false });
  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, "config", "app"),
      (snap) => {
        const d = (snap.exists() && snap.data().delegaciones) || {};
        setDeleg({
          ventasFactura: d.ventasFactura === true,
          administracionDespacha: d.administracionDespacha === true,
        });
      },
      () => {} // ante error, quedan en false (comportamiento normal)
    );
    return () => unsub();
  }, []);
  return deleg;
}
